import { ReactElement, ReactNode } from 'react';

import DynamicCollapseTrigger from 'src/components/ResumeCard/Body/Collapse/Trigger/Dynamic';
import useToggleState from 'src/hooks/useToggleState';

const MIN_COLLAPSED_LEN = 3;
const MAX_COLLAPSED_LEN = 4;

interface Props<T> {
    collection: Array<T>;
    renderItem: (value: T, index: number, array: Array<T>) => ReactNode;
    dataQa?: string;
}

const CollapseCollection = function <T>({ collection, renderItem, dataQa }: Props<T>): ReactElement | null {
    const [expanded, toggleExpanded] = useToggleState(false);

    const showTrigger = collection.length > MAX_COLLAPSED_LEN;
    const collectionToRender = showTrigger && !expanded ? collection.slice(0, MIN_COLLAPSED_LEN) : collection;

    return (
        <>
            {collectionToRender.map(renderItem)}
            {showTrigger && (
                <DynamicCollapseTrigger
                    expanded={expanded}
                    onToggle={toggleExpanded}
                    dataQa={`${dataQa || 'content'}-collapse-trigger`}
                />
            )}
        </>
    );
};

export default CollapseCollection;
